module.exports = __webpack_public_path__ + "img/4.d39bbbd7.jpg";